import { Device } from '@/types/device';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface StationsState {
  devices: Device[];
  devicesLoading: boolean;
  selectedStation: Device | null;
  selectedType: string;
  lat: number;
  lng: number;
  showUpdateHistory: boolean;
  showChangeSupportStatus: boolean;
  showChangeTags: boolean;
  showHistoryDevice: boolean;
}

const initialState: StationsState = {
  devices: [],
  devicesLoading: false,
  selectedStation: null,
  selectedType: 'all',
  showUpdateHistory: false,
  lat: 0,
  lng: 0,
  showChangeSupportStatus: false,
  showChangeTags: false,
  showHistoryDevice: false,
};

const { reducer, actions } = createSlice({
  name: 'stations_list_store',
  initialState,
  reducers: {
    resetStore: () => {
      return initialState;
    },
    setShowChangeSupportStatus(state: StationsState, action: PayloadAction<boolean>): void {
      state.showChangeSupportStatus = action.payload;
    },
    setShowChangeTags(state: StationsState, action: PayloadAction<boolean>): void {
      state.showChangeTags = action.payload;
    },
  },
});

export default reducer;

export const {
  resetStore: resetStationsStore,
  setShowChangeSupportStatus,
  setShowChangeTags,
} = actions;
